import MarketplaceWidgetFormView from "./MarketplaceWidgetFormView";

export { MarketplaceWidgetFormView };
